import { Users, Coffee, Monitor, Utensils, Calendar } from 'lucide-react'

export interface SpaceTemplate {
    id: string
    name: string
    label: string
    icon: any
    defaultAmenities: string[]
    defaultRules: {
        minAdvanceHours: number
        maxAdvanceDays: number
        bufferMinutes: number
        allowWeekend: boolean
    }
}

export const SPACE_TEMPLATES: Record<string, SpaceTemplate> = {
    room: {
        id: 'room',
        name: 'Sala de Reunião',
        label: 'Ideal para encontros de equipe e apresentações.',
        icon: Monitor,
        defaultAmenities: ['Wifi', 'Ar Condicionado', 'TV/Projetor', 'Quadro Branco'],
        defaultRules: {
            minAdvanceHours: 1,
            maxAdvanceDays: 30,
            bufferMinutes: 15,
            allowWeekend: false
        }
    },
    court: {
        id: 'court',
        name: 'Quadra Esportiva',
        label: 'Quadras de tênis, futebol ou poliesportivas.',
        icon: Calendar, // Usando Calendar como fallback
        defaultAmenities: ['Iluminação', 'Vestiário', 'Bancos'],
        defaultRules: {
            minAdvanceHours: 2,
            maxAdvanceDays: 14,
            bufferMinutes: 10,
            allowWeekend: true
        }
    },
    kiosk: {
        id: 'kiosk',
        name: 'Churrasqueira / Quiosque',
        label: 'Espaços gourmet para pequenos eventos.',
        icon: Utensils,
        defaultAmenities: ['Grelha', 'Pia', 'Mesas e Cadeiras', 'Geladeira'],
        defaultRules: {
            minAdvanceHours: 24,
            maxAdvanceDays: 60,
            bufferMinutes: 60,
            allowWeekend: true
        }
    },
    hall: {
        id: 'hall',
        name: 'Salão de Festas',
        label: 'Grandes espaços para celebrações.',
        icon: Users,
        defaultAmenities: ['Cozinha Completa', 'Som', 'Ar Condicionado', 'Mesas'],
        defaultRules: {
            minAdvanceHours: 168, // 1 semana
            maxAdvanceDays: 365,
            bufferMinutes: 1440, // 1 dia
            allowWeekend: true
        }
    },
    desk: {
        id: 'desk',
        name: 'Hot Desk / Mesa',
        label: 'Estação de trabalho individual em coworking.',
        icon: Coffee,
        defaultAmenities: ['Wifi Ultra', 'Café', 'Tomada', 'Cadeira Ergonômica'],
        defaultRules: {
            minAdvanceHours: 0,
            maxAdvanceDays: 7,
            bufferMinutes: 0,
            allowWeekend: false
        }
    },
    other: {
        id: 'other',
        name: 'Multiuso / Outros',
        label: 'Áreas flexíveis para diversas finalidades.',
        icon: Users,
        defaultAmenities: ['Wifi', 'Tomadas', 'Mesas Moduláveis'],
        defaultRules: {
            minAdvanceHours: 24,
            maxAdvanceDays: 30,
            bufferMinutes: 30,
            allowWeekend: true
        }
    }
}
